import RangeField from './RangeField.vue';

export default RangeField;
